"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_1 = require("./styles");
const Radiobutton = props => {
  const {
    isDisabled,
    isChecked,
    value,
    onChange = () => {},
    label,
    radiobuttonBg,
    radiobuttonBgActive,
    radiobuttonBgDisabled,
    radiobuttonBorderColor,
    checkMarkColor,
    dataAutomation = 'radio'
  } = props;
  const handleOnChange = e => {
    if (isDisabled) {
      return;
    }
    onChange(e);
  };
  return (0, jsx_runtime_1.jsxs)(styles_1.Container, {
    isDisabled: isDisabled,
    children: [(0, jsx_runtime_1.jsx)(styles_1.Input, {
      checked: isChecked,
      disabled: isDisabled,
      onChange: handleOnChange,
      value: value
    }), (0, jsx_runtime_1.jsx)(styles_1.StyledRadiobutton, {
      radiobuttonBg: radiobuttonBg,
      radiobuttonBgActive: radiobuttonBgActive,
      radiobuttonBgDisabled: radiobuttonBgDisabled,
      radiobuttonBorderColor: radiobuttonBorderColor,
      checkMarkColor: checkMarkColor,
      "data-automation": dataAutomation
    }), label && (0, jsx_runtime_1.jsx)(styles_1.Label, {
      children: label
    })]
  });
};
exports.default = Radiobutton;